/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { getComponentFromName } from '../../lib/utils';

import { useThemeClassName } from '../../contexts/ThemeContext';
import StyledButton from '../buttons/StyledButton';
import * as ButtonComponents from '../buttons/index';

import styles from '../../../styles/blocks/button.module.scss';

const propTypes = {
    style: PropTypes.string,
    label: PropTypes.string,
    className: PropTypes.string,
    isContainer: PropTypes.bool,
    containerClassName: PropTypes.string,
};

const defaultProps = {
    style: null,
    label: null,
    className: null,
    isContainer: false,
    containerClassName: null,
};

function ButtonBlock({ style, label, className, isContainer, containerClassName, ...props }) {
    const themeClassName = useThemeClassName(styles);
    const ButtonComponent = getComponentFromName(ButtonComponents, style);
    return (
        <div className={classNames([styles.container, themeClassName, className])}>
            <div
                className={classNames([
                    styles.inner,
                    {
                        [styles.isContainer]: isContainer,
                        [containerClassName]: isContainer && containerClassName !== null,
                    },
                ])}
            >
                {ButtonComponent !== null ? (
                    <ButtonComponent label={label} {...props} />
                ) : (
                    <StyledButton>{label}</StyledButton>
                )}
            </div>
        </div>
    );
}

ButtonBlock.propTypes = propTypes;
ButtonBlock.defaultProps = defaultProps;

export default ButtonBlock;
